import type { ReviewKind } from './types';

interface KindMeta {
  title: string;
  breadcrumb: string;
  bannerBody: (count: number) => string;
  approveAllLabel: string;
  dismissAllLabel: string;
  emptyTitle: string;
  emptyDesc: string;
  errorTitle: string;
  errorDesc: string;
}

export const KIND_META: Record<ReviewKind, KindMeta> = {
  archive: {
    title: 'Review archive',
    breadcrumb: 'Review archive',
    bannerBody: (n) => `Vela found ${n} unused account${n !== 1 ? 's' : ''}. Each one had no activity for over 90 days. Archived accounts can be restored from Cleanup history for 30 days.`,
    approveAllLabel: 'Archive all',
    dismissAllLabel: 'Dismiss all',
    emptyTitle: 'Nothing to archive',
    emptyDesc: "Every account in your chart has had activity in the past 90 days, so Vela doesn't see any unused ones to archive right now.",
    errorTitle: "We couldn't load this just now",
    errorDesc: 'Vela ran into a problem fetching your unused accounts. Try again in a moment, or head back to Chart of accounts.',
  },
  merge: {
    title: 'Review merge',
    breadcrumb: 'Review merge',
    bannerBody: (n) => `Vela found ${n} duplicate pair${n !== 1 ? 's' : ''}. Review each one, swap merge direction if needed, then approve. Merges are reversible from Cleanup history for 30 days.`,
    approveAllLabel: 'Merge all',
    dismissAllLabel: 'Dismiss all',
    emptyTitle: 'No duplicates found',
    emptyDesc: "Vela didn't find any duplicate accounts in your chart right now. Your account names look distinct.",
    errorTitle: "We couldn't load this just now",
    errorDesc: 'Vela ran into a problem fetching your duplicates. Try again in a moment, or head back to Chart of accounts.',
  },
  categorize: {
    title: 'Review categorize',
    breadcrumb: 'Review categorize',
    bannerBody: (n) => `Vela wants to categorize ${n} transaction${n !== 1 ? 's' : ''} sitting under Uncategorized. Review each suggestion and approve, edit, or dismiss.`,
    approveAllLabel: 'Approve all',
    dismissAllLabel: 'Dismiss all',
    emptyTitle: 'Nothing to categorize',
    emptyDesc: 'No uncategorized transactions right now. Vela will let you know when something new comes in that needs a category.',
    errorTitle: "We couldn't load this just now",
    errorDesc: 'Vela ran into a problem fetching your uncategorized transactions. Try again in a moment.',
  },
};